module.exports = __webpack_public_path__ + "static/media/speaker_body_point.29e55f27.png";